// @ts-ignore
import('./bootstrap');
